// @ts-ignore
import('./bootstrap');
